<template>
  <div id="CredentialForm">
    <div class="sun not-full">
      <div class="title">{{ title }}</div>
      <pre class="description">{{ description }}</pre>
      <input class="id" :placeholder="placeholderID" v-model="user_id" />
      <input
        type="password"
        class="pw"
        :placeholder="placeholderPW"
        v-model="user_password"
      />
      <button class="link" @click="openLink">
        {{ linkTitle }}
        <img src="@/assets/images/ic-left-blue.svg" alt=">" />
      </button>
    </div>
    <FooterButton
      :title="isLoading ? '연동중입니다...' : '다음'"
      :active="user_id && user_password"
      @click="submit"
    />
  </div>
</template>

<script>
import FooterButton from '@/components/footer/button'

export default {
  name: 'Form',
  props: [
    'title',
    'description',
    'placeholderID',
    'placeholderPW',
    'linkTitle',
    'link',
    'provider',
  ],
  components: {
    FooterButton,
  },
  data: function () {
    return {
      credential: null,
      user_id: null,
      user_password: null,
      isLoading: false,
    }
  },
  chimera: {
    getCredential() {
      return {
        url: '/credentials/provider/',
        method: 'get',
        params: { provider: this.provider },
      }
    },
    postCredential() {
      return {
        url: '/credentials/',
        method: 'post',
        params: {
          provider: this.provider,
          user_id: this.user_id,
          user_password: this.user_password,
        },
      }
    },
    patchCredential() {
      return {
        url: `/credentials/${this.credential ? this.credential.uuid : null}/`,
        method: 'patch',
        params: {
          provider: this.provider,
          user_id: this.user_id,
          user_password: this.user_password,
        },
      }
    },
  },
  async created() {
    await this.getCredential.fetch()
    if (this.getCredential.data) {
      this.credential = this.getCredential.data
      this.user_id = this.credential.user_id
    }
  },
  methods: {
    async submit() {
      this.isLoading = true
      let api =
        this.credential && this.credential.uuid
          ? this.patchCredential
          : this.postCredential

      try {
        await api.fetch()
      } catch (e) {
        this.$emit('fail', e.data)
        this.isLoading = false
        return
      }
      this.$emit('success', api.data)
      this.isLoading = false
    },
    openLink() {
      if (this.link) {
        window.open(this.link, '_blank')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
#CredentialForm {
  .title {
    font-family: NanumSquareB;
    font-size: 22px;
    letter-spacing: -0.39px;
    text-align: center;
    color: #333333;
    margin-top: calc(83vh / 647 * 100);
  }
  .description {
    font-size: 16px;
    line-height: 1.56;
    text-align: center;
    color: #727d8c;
  }
  input {
    border-radius: 4px;
    border: solid 1px #d7e1ea;
    background-color: #ffffff;
    padding: 15px 10px;
    &.id {
      margin-top: 22px;
    }
    &.pw {
      margin-top: 10px;
    }
  }
  button.link {
    width: 100%;
    height: 38px;
    border-radius: 19px;
    background-color: #f4faff;
    font-weight: 700;
    font-size: 16px;
    line-height: 1.44;
    text-align: center;
    color: #1baaf1;
    margin-top: 20px;
    img {
      margin-left: 8px;
      width: 8px;
      height: auto;
      display: inline;
    }
  }
}
</style>
